import { createContext, useContext, useMemo, useState } from 'react';

const initialState = false;

export const UnassignedStemsContext = createContext({
  includeUnassignedStems: initialState,
  setIncludeUnassignedStems: () => {},
});

export const UnassignedStemsContextProvider = ({ children }) => {
  const [includeUnassignedStems, setIncludeUnassignedStems] = useState(
    initialState,
  );

  const value = useMemo(
    () => ({
      includeUnassignedStems,
      setIncludeUnassignedStems,
    }),
    [includeUnassignedStems],
  );

  return (
    <UnassignedStemsContext.Provider value={value}>
      {children}
    </UnassignedStemsContext.Provider>
  );
};

export const useUnassignedStemsContext = () =>
  useContext(UnassignedStemsContext);
